import "../Css/groovePQR_pdf.css";
import PQR_Footer from "./PQR_Footer";



import TTS_pdf_headerWPQpage3 from "./TTS_pdf_headerPQRpage3";

const WPQTubeToTubesheet_pdf_page3 = (
  { pdf, setpdf, PreviewUrl, previewuser, previewapproved },
  props,
  wld
) => {


  const width = "72.6%";
  const col1Class = "left7-td-noleft";

  function Tear_Test() {
    const rows = [];

    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.Tear_Test || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];

        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft" style={{ whiteSpace: "nowrap" }}>
              {item.PQR_Tear_TubeNo !== "" ? item.PQR_Tear_TubeNo : "--"}
            </td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }} >
              {item.PQR_Tear_Observation !== "" ? item.PQR_Tear_Observation : "--"}
            </td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>
              {item.PQR_Tear_Results !== "" ? item.PQR_Tear_Results : "--"}
            </td>
          </tr>
        );
      }
    }

    return rows;
  }


  const getValueOrDefault = (value) => value !== "" ? value : '--';

  function Pull_out() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.PullOut_Test || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_PullOut_TubeNo)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }} >{getValueOrDefault(item.PQR_PullOut_Location)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_PullOut_Load)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_PullOut_Fracture)}</td>
          </tr>
        );
      }
    }
    return rows;
  }

  function Other_Test() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.Other_Test || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft" style={{ whiteSpace: "nowrap" }} >{getValueOrDefault(item.PQR_OT_TypeofTest)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }} >{getValueOrDefault(item.PQR_OT_Acceptance_Criteria)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_OT_Results)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_OT_Remarks)}</td>
          </tr>
        );
      }
    }
    return rows;
  }

  function Radiography_Test() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.Radiography_Test || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft" style={{ whiteSpace: "nowrap" }} >{getValueOrDefault(item.PQR_Radio_TubeNo)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_Radio_Acceptance_Criteria)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_Radio_Observation)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_Radio_Results)}</td>
          </tr>
        );
      }
    }
    return rows;
  }

  function Pullout_Test_tab2() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.PullOut_Test_Table || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft" style={{ whiteSpace: "nowrap" }} >{item.PQR_PullOut_Acceptance_Criteria !== "" ? item.PQR_PullOut_Acceptance_Criteria : '--'}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{item.PQR_PullOut_Observation !== "" ? item.PQR_PullOut_Observation : '--'}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{item.PQR_PullOut_Results !== "" ? item.PQR_PullOut_Results : '--'}</td>
          </tr>
        );
      }
    }
    return rows;
  }

  function Hardness_Test() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.Hardness_Test || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_HT_TypeofTest)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }} >{getValueOrDefault(item.PQR_HT_Tube_No)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_HT_BM_Tubesheet)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_HT_HAZ_Tubesheet)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_HT_Weld)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_HT_HAZ_Tube)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_HT_BM_Tube)}</td>
            <td className="PQR_right" style={{ whiteSpace: "nowrap" }}>{getValueOrDefault(item.PQR_HT_Results)}</td>
          </tr>
        );
      }
    }
    return rows;
  }

  return (
    <div className="MainPDF">
      <TTS_pdf_headerWPQpage3 pdf={pdf}></TTS_pdf_headerWPQpage3>
      {/* -------------------------TEAR TEST---------------------------------*/}
      {pdf[0]?.tearCheck !== "No" && (<>
        <div className="group">
          <div className="PQRbasemetal" style={{ width: { width } }}>
            TEAR TEST
          </div>
        </div>
        <table className="PQRTablePg2" style={{ width: { width } }}>
          <tr>
            <th className="PQR_border" style={{ width: "30%" }}>TUBE NO</th>
            <th className="PQR_noleft" style={{ width: "48%" }}>Observation</th>
            <th className="PQR_noleft" style={{ width: "28%" }}>Results</th>

          </tr>

          {Tear_Test()}
        </table>
        <table className="PQRTablePg2" style={{ width: { width } }}>
          <tr>
            <th className="PQR_border" style={{ width: "80px" }}>Notes</th>
            <td className="PQR_noleft" style={{ textAlign: "left" }}>{pdf[0]?.PQR_Tear_Notes}</td>
          </tr>
          <tr>
            <th className="PQR_noTop" style={{ width: "80px" }}>Report Number</th>
            <td className="PQR_Botmrt" style={{ textAlign: "left" }}>{pdf[0]?.PQR_Tear_ReportNumHorizontal}</td>
          </tr>
        </table>
      </>)}
      {/* -------------------------Pull out TEST---------------------------------*/}
      {pdf[0]?.pullout_check !== "No" && (<>
        <div className="group">
          <div className="PQRbasemetal" style={{ width: { width } }}>
            PULL OUT TEST
          </div>
        </div>
        <table className="PQRTablePg2" style={{ width: "570px" }}>
          <tr>
            <th className="PQR_border" style={{ width: "15%" }}>Tube No</th>
            <th className="PQR_noleft" style={{ width: "10%" }}>Location</th>
            <th className="PQR_noleft" style={{ width: "10%" }}>Load</th>
            <th className="PQR_noleft" style={{ width: "28%" }}>Fracture</th>
          </tr>
          {Pull_out()}
        </table>
        <table className="PQRTablePg2" style={{ width: { width } }}>
          <tr>
            <th className="PQR_border" style={{ width: "100px" }}>Notes</th>
            <td className="PQR_noleft" style={{ textAlign: "left" }}>{pdf[0]?.PQR_PullOut_Notes}</td>
          </tr>
          <tr>
            <th className="PQR_noTop" style={{ width: "100px" }}>Report Number</th>
            <td className="PQR_Botmrt" style={{ textAlign: "left" }}>{pdf[0]?.PQR_PullOut_ReportNumHorizontal}</td>
          </tr>
        </table>
        {/* -------------------------------------------------------------------------------------------- */}
        <div className="group">
          <div className="PQRbasemetal" style={{ whiteSpace: "nowrap", wordBreak: "nowrap", width: "130px" }}>
            Calculation for Fr value
          </div></div>

        <table className="PQRTablePg2" style={{ width: "570px" }}>
          <tr className="PQRtrhide PQR_noBotm">
            <th className=" PQR_noBotm PQRthhide" style={{ width: "10%" }} >
              Minimum Breaking Load (kN)
            </th>
            <td className={col1Class} style={{ width: "10%", whiteSpace: "nowrap", textAlign: "left" }}>
              {pdf[0]?.PQR_PullOut_MinBreakLoad}
            </td></tr>
          <tr className="PQRtrhide PQR_noBotm">
            <th className=" PQR_noBotm PQRthhide" style={{ width: "10%" }} >
              Area of Tube Material (mm²)
            </th>
            <td className={col1Class} style={{ width: "10%", whiteSpace: "nowrap", textAlign: "left" }}>
              {pdf[0]?.PQR_PullOut_AreaTubeMaterial}
            </td></tr>
          <tr className="PQRtrhide PQR_noBotm ">
            <th className=" PQR_noBotm PQRthhide" style={{ width: "10%" }}>
              Minimum Specified Tensile Strength of Tube(MPa)
            </th>
            <td className={col1Class} style={{ whiteSpace: "nowrap", textAlign: "left" }}>
              {pdf[0]?.PQR_PullOut_MinTensilStrength}
            </td></tr>
          <tr className="PQRtrhide PQR_noBotm ">
            <th className=" PQR_noBotm PQRthhide" style={{ width: "10%" }}>
              Minimum Breaking Stress <br></br>'('=   Minimum Breaking Load in kN <br></br>/ Area of Tube Material in mm²)
            </th>
            <td className={col1Class} style={{ whiteSpace: "nowrap", textAlign: "left" }}>
              {pdf[0]?.PQR_PullOut_MinBreakStress}
            </td></tr>
          <tr className="PQRtrhide PQR_noBotm ">
            <th className=" PQR_noBotm PQRthhide" style={{ width: "10%" }}>
              Fr Value ( = Minimum Breaking Stress /<br></br> Minimum Tensile Strength of Tube )
            </th>
            <td className={col1Class} style={{ whiteSpace: "nowrap", textAlign: "left" }}>
              {pdf[0]?.PQR_PullOut_FrValue}
            </td></tr>

        </table>

        {/* </div> */}
        <div className="group">
        </div>
        <table className="PQRTablePg2" style={{ width: { width } }}>
          <tr>
            <th className="PQR_border" style={{ width: "32%" }}>Acceptance Criteria</th>
            <th className="PQR_noleft" style={{ width: "48%" }}>Observation </th>
            <th className="PQR_noleft" style={{ width: "32%" }}>Results</th>

          </tr>

          {Pullout_Test_tab2()}
        </table>
        <table className="PQRTablePg2" style={{ width: { width } }}>
          <tr>
            <th className="PQR_border" style={{ width: "100px" }}>Notes</th>
            <td className="PQR_noleft" style={{ textAlign: "left" }}>{pdf[0]?.PQR_PullOut_AccCriteria_Notes}</td>
          </tr>
          <tr>
            <th className="PQR_noTop" style={{ width: "100px" }}>Report Number</th>
            <td className="PQR_Botmrt" style={{ textAlign: "left" }}>{pdf[0]?.PQR_PullOut_ReportNumHorizontal}</td>
          </tr>
        </table>
      </>)}
      {/* ---------------------------------HARDNESS TEST--------------------------- */}
      {pdf[0]?.hardnessCheck !== "No" && (<>
        <div className="group">
          <div className="PQRbasemetal" style={{ width: { width } }}>
            HARDNESS TEST
          </div>
        </div>

        <table className="PQRTablePg2" style={{ width: "570px" }}>
          <tr>
            <th className="PQR_border">Type( Scale)</th>
            <th className="PQR_noleft">Tube No</th>
            <th className="PQR_noleft">BM - Tube Sheet</th>
            <th className="PQR_noleft">HAZ - Tube Sheet</th>
            <th className="PQR_noleft">Weld</th>
            <th className="PQR_noleft">HAZ - Tube</th>
            <th className="PQR_noleft">BM - Tube</th>
            <th className="PQR_noleft">Results</th>

          </tr>


          {Hardness_Test()}
        </table>
        <table className="PQRTablePg2" style={{ width: "570px" }}>

          <tr>
            <th className="PQR_border" style={{ width: "80px" }}>Notes</th>
            <td className="PQR_noleft" style={{ textAlign: "left" }}>{pdf[0]?.PQR_HT_Notes}</td>
          </tr>
          <tr>
            <th className="PQR_noTop" style={{ width: "80px" }}>Report Number</th>
            <td className="PQR_Botmrt" style={{ textAlign: "left" }}>{pdf[0]?.PQR_HT_ReportNumHorizontal}</td>
          </tr>
        </table>
      </>)}

      {/* ------------------------------Radiography test---------------------------------------------         */}
      {pdf[0]?.radioCheck !== "No" && (<>
        <div className="group">
          <div className="PQRbasemetal" style={{ width: { width } }}>
            RADIOGRAPHY TEST
          </div>
        </div>
        <table className="PQRTablePg2" style={{ width: "570px" }}>
          <tr>
            <th className="PQR_border" style={{ width: "25%" }}>Tube No</th>
            <th className="PQR_border" style={{ width: "25%" }}>Acceptance Criteria</th>
            <th className="PQR_noleft" style={{ width: "28%" }}>Observation</th>
            <th className="PQR_noleft" style={{ width: "22%" }}>Results</th>

          </tr>

          {Radiography_Test()}
        </table>
        <table className="PQRTablePg2" style={{ width: "570px" }}>

          <tr>
            <th className="PQR_border" style={{ width: "35px" }}>Notes</th>
            <td className="PQR_noleft" style={{ textAlign: "left" }}>{pdf[0]?.PQR_Radio_Notes}</td>
          </tr>
        </table>
      </>)}

      {/* ------------------------------------other test---------------------------------      */}
      {pdf[0]?.otherCheck !== "No" && (<>
        <div className="group">
          <div className="PQRbasemetal" style={{ width: { width } }}>
            OTHER TEST
          </div>
        </div>
        <table className="PQRTablePg2" style={{ width: "570px" }}>
          <tr>
            <th className="PQR_border" style={{ width: "30%" }}>Type of Test</th>
            <th className="PQR_noleft" style={{ width: "23%" }}>Acceptance Criteria</th>
            <th className="PQR_noleft" style={{ width: "23%" }}>Results</th>
            <th className="PQR_noleft" style={{ width: "23%" }}>Remarks</th>

          </tr>

          {Other_Test()}
        </table>
        <table className="PQRTablePg2" style={{ width: "570px" }}>

          <tr>
            <th className="PQR_border" style={{ width: "35px" }}>Notes</th>
            <td className="PQR_noleft" style={{ textAlign: "left" }}>{pdf[0]?.PQR_OT_Notes}</td>
          </tr>
        </table>
      </>)}

      {/* <p className="PQRcertifont" >We certify that the statement in this record are correct and that the test welds were prepared, welded and tested in the accordance with the requirements of Section IX of the ASME code </p> */}

      <div className="PQRcertifont">We certify that the statements in this record are correct and that the test welds were prepared, welded, and tested in accordance with the requirements of Section IX of the ASME Boiler and Pressure Vessel Code.
      </div>

      <div id="footer" style={{position:"fixed",top:"3005px"}} >
        <PQR_Footer pdf={pdf} previewuser={previewuser} previewapproved={previewapproved}></PQR_Footer>

      </div>
      <br></br>
      <br></br>
      <div id="footer" style={{position:"fixed",top:"3090px"}} >
        <table className="WPSfooter">
          <tr>
            <td>Page 3 of 3</td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default WPQTubeToTubesheet_pdf_page3;
